class PickAndMix extends HTMLElement {
    constructor() {
        super()
        
        this.itemsQty = Number(this.dataset.itemsQty) ?? 3
        this.fixedPrice = Number(this.dataset.fixedPrice) ?? null
        this.discount = Number(this.dataset.discount) ?? 0
        this.bundleId = this.dataset.bundleId ?? null
        this.bundleCustomImage = this.dataset.bundleCustomImage ?? null
        this.bundleCustomTitle = this.dataset.bundleCustomTitle ?? null

        this.items = []
    }

    connectedCallback() {
        this.stepElements = document.querySelectorAll('.pick-and-mix .pick-and-mix__step')
        this.itemsElement = this.querySelector('.pick-and-mix__items')
        this.addBtn = this.querySelector('.pick-and-mix__add-btn')
        this.productsCount = this.querySelectorAll('.pick-and-mix__count')
        this.productsCountMobile = this.querySelector('.pick-and-mix__count--mobile')
        this.productsCountSubtext = this.querySelector('.pick-and-mix__count-subtext')
        this.giftWrapping = this.querySelector(".gift-wrapping__checkbox")
        this.giftWrappingCheckbox = this.querySelector(".gift-wrapping__checkbox input[type='checkbox']")

        document.addEventListener('click', this.handleClick.bind(this))
        this.addBtn?.addEventListener('click', this.addToCart.bind(this))
        window.addEventListener('collection:refreshed', this.updateUI.bind(this))

        this.updateUI()
    }

    handleClick(event) {
        if(event.target.closest('.pick-and-mix__item-remove')) {
            let index = Number(event.target.closest('.pick-and-mix__item-remove').dataset.index)
            this.removeItem(index)
            return
        }
        
        if(event.target.closest('.pick-and-mix__product-btn.selected')) {
            let index = Number(event.target.closest('.pick-and-mix__product-btn.selected').dataset.index)
            this.removeItem(index)
            return
        }

        if(event.target.closest('.pick-and-mix__product-btn')) {
            let btn = event.target.closest('.pick-and-mix__product-btn')

            this.addItem({
                id: btn.id,
                img: event.target.closest('.card-wrapper')?.querySelector('img')?.src ?? '',
                price: Number(btn.dataset.price) ?? 0,
                priceDiscounted: Number(btn.dataset.priceDiscounted) ?? 0,
                giftWrapping: !!btn.dataset.giftWrapping
            })

            return
        }
    }

    addItem(item) {
        if(this.items.length >= this.itemsQty) return
        if(this.items.find(i => i.id === item.id)) return

        this.items.push(item)
        this.updateUI()
    }

    removeItem(index) {
        this.items.splice(index, 1)
        this.updateUI()
    }

    clearItems() {
        this.items = []
        this.updateUI()
    }

    updateUI() {
        let itemsHTML = ''

        for(let i=0; i<this.itemsQty; i++) {
            let item = this.items[i]

            let img = `<span class="pick-and-mix__item-index">${i + 1}</span>`
            if(!!item) img = `<img src="${item.img}" alt="Item image" loading="lazy" width="71" height="90" />`

            let removeBtn = ''
            if(!!item) {
                removeBtn = `
                    <button class="pick-and-mix__item-remove" type="button" aria-label="Remove item" data-index="${i}">
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                            <path d="M2 2L12 12M2 12L12 2" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </button>
                `
            }

            itemsHTML += `
                <div class="pick-and-mix__item">
                    <div class="pick-and-mix__item-img">
                        ${img}
                        ${removeBtn}
                    </div>
                </div>
            `
        }

        this.itemsElement.innerHTML = itemsHTML

        this.updateButtonState()
        this.updateProductCards()
    }

    updateProductCards() {
        if(!!!this.stepElements) return

        this.stepElements.forEach(stepElement => {
            let pickers = Array.from(stepElement.querySelectorAll('.pick-and-mix__product-btn'))

            let itemAdded = this.items.find(item => !!pickers.some(picker => picker.id === item.id))
            if(!!itemAdded) {
                pickers.forEach(picker => {
                    if(picker.id === itemAdded.id) {
                        picker.classList.add('selected')
                        picker.classList.remove('disabled')
                        picker.removeAttribute('disabled')
                        picker.innerHTML = 'Delete'
                        picker.setAttribute('data-index', `${this.items.indexOf(itemAdded)}`)
                        
                    }else {
                        picker.classList.add('disabled')
                        picker.setAttribute('disabled', 'disabled')
                    }
                })

            }else {
                pickers.forEach(picker => {
                    picker.classList.remove('selected')
                    picker.innerHTML = `Add to Bundle`
                    picker.classList.remove('disabled')
                    picker.removeAttribute('disabled')
                    picker.removeAttribute('data-index')
                })
            }

        })
    }

    updateButtonState() {
        this.addBtn.disabled = this.items.length !== this.itemsQty
        this.addBtn.classList.toggle('disabled', this.items.length !== this.itemsQty)

        if(this.items.length === 0) {
            this.productsCount.forEach(count => count.innerText = `You have no products selected`)
            this.productsCountMobile.innerText = `0 products selected`
            this.productsCountSubtext.innerText = 'Select one from each section'

        }else if(this.items.length !== this.itemsQty) {
            this.productsCount.forEach(count => count.innerText = `${this.itemsQty - this.items.length} products missing`)
            this.productsCountMobile.innerText = `${this.items.length} products selected`
            this.productsCountSubtext.innerText = 'To be able to complete your combo'
        }else if(this.items.length === this.itemsQty) {
            this.productsCount.forEach(count => count.innerText = `Bundle ready!`)
            this.productsCountMobile.innerText = `${this.items.length} products selected`
            this.productsCountSubtext.innerText = 'You can now add the bundle to your cart'
        }

        if(!!this.giftWrapping) {
            if(this.items.some(item => !item.giftWrapping)) this.giftWrapping.classList.add('hidden')
            else this.giftWrapping.classList.remove('hidden')
        }
    }

    async addToCart() {
        if(this.items.length !== this.itemsQty) return

        if(!!this.bundleId || !!this.bundleCustomImage || !!this.bundleCustomTitle) await this.addBundleToCart()
        else await this.addIndividualItemsToCart()

        this.clearItems()
    }

    async addBundleToCart() {
        let payload = {}

        let bundleId = !!this.bundleId ? this.bundleId : this.items[0].id

        if(!!this.fixedPrice) {
            let sum = this.items.reduce((acc, item) => acc + item.priceDiscounted, 0)
            let factor = this.fixedPrice / sum

            let lineItemComponents = this.items.map(item => {
                let price = Math.trunc(item.priceDiscounted * factor)

                return { id: item.id, price: price }  
            })

            let cheaperItem = lineItemComponents.find(item => item.price === Math.min(...lineItemComponents.map(i => i.price)))
            let difference = this.fixedPrice - lineItemComponents.reduce((acc, item) => acc + item.price, 0)
            if(!!cheaperItem && difference !== 0) cheaperItem.price += difference

            payload = { id: bundleId, quantity: 1, properties: { '_lineItemComponents': JSON.stringify(lineItemComponents) } }
        }

        if(!!this.discount || (!!!this.fixedPrice && this.discount === 0)) {
            let lineItemComponents = this.items.map(item => {
                let price = (item.priceDiscounted - (item.priceDiscounted * (this.discount / 100))) / 100

                return { id: item.id, price: price }
            })

            let cheaperItem = lineItemComponents.find(item => item.price === Math.min(...lineItemComponents.map(i => i.price)))
            let sum = lineItemComponents.reduce((acc, item) => acc + item.price, 0)
            let difference = Math.round(sum) - sum
            if(!!cheaperItem && difference !== 0) cheaperItem.price += difference

            payload = { id: bundleId, quantity: 1, properties: { '_lineItemComponents': JSON.stringify(lineItemComponents) } }
        }

        if(!!this.bundleCustomImage) payload.properties['_customImage'] = this.bundleCustomImage
        if(!!this.bundleCustomTitle) payload.properties['_customTitle'] = this.bundleCustomTitle

        if(this.giftWrappingCheckbox?.checked && !this.items.some(item => !item.giftWrapping)) {
            payload.properties['giftWrappingPrice'] = this.giftWrappingCheckbox.dataset.giftWrappingPrice
            payload.properties['_giftWrapping'] = 'true'
            payload.properties['_partOfGiftWrappingCollection'] = 'true'
        }

        await window.$Cart.addItem(payload)
    }

    async addIndividualItemsToCart() {
        let payload = this.items.map(item => ({ id: item.id, quantity: 1 }))
        await window.$Cart.addItem(payload)
    }
}
customElements.define('pick-and-mix', PickAndMix)

class PickAndMixProducts extends HTMLElement {
    constructor() {
        super()

        this.init()
    }

    async init() {
        this.collections = Array.from(this.querySelectorAll('[data-collection]'))

        for(let i=0; i<this.collections.length; i++) {
            const collection = this.collections[i]
            await this.getData(collection, true)
        }
    }

    async getData(collection) {
        let collectionURL = collection.dataset.collection
        let filters = ''

        let selects = collection.closest('.pick-and-mix__step').querySelectorAll('.pick-and-mix__filter select')
        selects?.forEach(select => {
            let filterName = select.name
            let filterValue = select.value

            if(!!filterValue && filterValue !== 'all') {
                filters += `${encodeURIComponent(filterName)}=${encodeURIComponent(filterValue)}&`
            }
        })
        filters = filters.slice(0, -1) // Remove trailing &

        try{
            let URL = `${collectionURL}?${filters}&view=pick-and-mix-products`
            let response = await fetch(URL)
            let data = await response.text()
            
            let parser = new DOMParser()
            let doc = parser.parseFromString(data, 'text/html')
            let productsHTML = doc.querySelector('#products').innerHTML

            collection.innerHTML = productsHTML
            
            collection.closest('slider-component')?.init()

            let filtersHTML = doc.querySelector('#filters')?.innerHTML ?? ''
            let filtersContainer = collection.closest('.pick-and-mix__step').querySelector('.pick-and-mix__collection-filters')

            if(!!filtersContainer && filtersHTML.length > 0) filtersContainer.innerHTML = filtersHTML

            this.addFilterListener()

            window.dispatchEvent(new Event('collection:refreshed'))

        }catch(error) {
            console.error('Error fetching collection products:', error)
        } 
    }

    addFilterListener() {
        let filters = this.querySelectorAll('.pick-and-mix__filter')

        filters.forEach(filter => {
            filter.querySelector('select').addEventListener("change", async (event) => {
                filters.forEach(f => {
                    f.classList.add('disabled')
                    f.querySelector('select').setAttribute('disabled', 'disabled')
                })

                let label = filter.querySelector('label')
                label.innerHTML = filter.innerText.split(':')[0] + ': ' + `<span>${event.target.options[event.target.selectedIndex].text}</span>`

                let collection = filter.closest('.pick-and-mix__step').querySelector('[data-collection]')
                await this.getData(collection)

                filters.forEach(f => {
                    f.classList.remove('disabled')
                    f.querySelector('select').removeAttribute('disabled')
                })
            })
        })
    }
}
customElements.define('pick-and-mix-products', PickAndMixProducts)